<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">{{ dropdownLabel }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <b-table
                v-if="this.table_number === '1.1' || this.table_number === '1.5' || this.table_number === '1.15'"
                :items="flattenedItems"
                :fields="tableFields1_1"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="7" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template #bottom-row="data" v-if="table_number === '1.1' || table_number === '1.5'">
                    <b-th colspan="5" class="text-right"></b-th>
                    <b-th colspan="1" class="text-left">{{'Доходы, всего'}}</b-th>
                    <b-th colspan="1" class="text-center">
                        {{ table_number === '1.1' ? '500' : table_number === '1.5' ? '800' : '' }}
                    </b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.fact) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.evaluation) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_1) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_2) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_3) }}</b-th>
                </template>
                <template #head(action)>
                    <i
                        class="icon icon-chevron-circle"
                        @click="openAllChilds"
                        style="cursor: pointer"
                    ></i>
                </template>
                <template #cell(action)="data">
                    <b-button v-if="data.item.type === 1" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(kat)="data">
                    <div v-if="data.item.type === 1">{{ data.value }}</div>
                    <b-button v-if="data.item.type === 2" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(clss)="data">
                    <div v-if="data.item.type === 2">{{ data.value.toString().padStart(2, '0') }}</div>
                    <b-button v-if="data.item.type === 3" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(pcl)="data">
                    <div v-if="data.item.type === 3">{{ data.value }}</div>
                </template>
                <template #cell(spf)="data">
                    <div v-if="data.item.type === 5">{{ data.value.toString().padStart(2, '0') }}</div>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left" style="width: 600px">{{ data.value }}</div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.item.row_code }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <span
                            v-if="hasDataError(data.item.row_code, data.item, data.field.key, table_number)"
                            class="warning-icon"
                            :title="getErrorTitle(data.item.row_code, data.item, data.field.key, table_number)"
                        >⚠</span>
                        {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                    </div>
                </template>
            </b-table>
            <b-table
                v-if="costTableNumbers.includes(this.table_number)"
                :items="flattenedItems"
                :fields="tableFieldsCost"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="5" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template #bottom-row="data">
                    <b-th colspan="3" class="text-right"></b-th>
                    <b-th colspan="1" class="text-left">{{ table_number === '1.3' ?
                        'Выбытие денежных средств по операционной деятельности, всего' : 'Уменьшение, всего'}}</b-th>
                    <b-th colspan="1" class="text-center">
                        {{ table_number === '1.3' ? '160' : '100' }}
                    </b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.fact) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.evaluation) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_1) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_2) }}</b-th>
                    <b-th colspan="1" class="text-right">{{ $n(totalRow.forecast_3) }}</b-th>
                </template>
                <template #head(action)>
                    <i
                        class="icon icon-chevron-circle"
                        @click="openAllChilds"
                        style="cursor: pointer"
                    ></i>
                </template>
                <template #cell(action)="data">
                    <b-button v-if="data.item.type === 3" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(pcl)="data">
                    <div v-if="data.item.type === 3">{{ data.value }}</div>
                </template>
                <template #cell(spf)="data">
                    <div v-if="data.item.type === 4">{{ data.value }}</div>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left" style="width: 600px">{{ data.value }}</div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.item.row_code }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <span
                            v-if="hasDataError(data.item.row_code, data.item, data.field.key, table_number)"
                            class="warning-icon"
                            :title="getErrorTitle(data.item.row_code, data.item, data.field.key, table_number)"
                        >⚠</span>
                        {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                    </div>
                </template>
            </b-table>
            <b-table
                v-if="!showNoteTable && (moveTableNumbers.includes(this.table_number) || balanceTableNumbers.includes(this.table_number)
                || table_number === '1.18' || table_number === '1.20' || table_number === '1.28' || table_number === '1.30')"
                :items="formApp6"
                :fields="tableFieldsMovement"
                :tbody-tr-class="rowClass"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="2" class="text-center"></b-th>
                        <b-th v-if="source === 'main'" colspan="1" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left" style="width: 600px">{{ data.value }}</div>
                </template>
                <template v-if="source === 'main'" #cell(note_number)="data">
                    <div class="text-center">
                        <span
                            v-for="(note, index) in getNotes(data.item.note)"
                            :key="index"
                        >
                            <template v-if="['18', '19', '33', '34', '35', '36', '37'].includes(note)">
                                <span :title="getNoteTooltip(note)">
                                    {{ note }}*
                                </span>
                            </template>
                            <template v-else-if="!['10', '12'].includes(note)">
                                <a
                                    href="#"
                                    @click.prevent="openNote(`${note}.1`, data.item.name_ru, data.item.line_code)"
                                >
                                    {{ note }}
                                </a>
                            </template>
                            <template v-else>
                                {{ note }}
                            </template>
                            <span v-if="index < getNotes(data.item.note).length - 1">
                                ,
                            </span>
                        </span>
                    </div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.item.line_code }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <template v-if="table_number === '1.13' && ['100', '010', '020', '030', '200'].includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.18' && inputType118.includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{
                                    'disabled-input':
                                      (source === 'main') ||
                                      (source === 'app6' && (access_level === 1 || !actualVersion))}"
                                   :disabled="
                                    (source === 'main') ||
                                    (source === 'app6' && (access_level === 1 || !actualVersion)) "
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.20' && inputType120.includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{
                                    'disabled-input':
                                      (source === 'main') ||
                                      (source === 'app6' && (access_level === 1 || !actualVersion))}"
                                   :disabled="
                                    (source === 'main') ||
                                    (source === 'app6' && (access_level === 1 || !actualVersion)) "
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.18' && ['110', '111', '112', '113', '210', '211'].includes(data.item.line_code)">
                            {{ 'x' }}
                        </template>
                        <template v-else-if="table_number === '1.20' && ['010', '011', '012', '013', '120'].includes(data.item.line_code)">
                            {{ 'x' }}
                        </template>
                        <template v-else-if="table_number === '1.22' && ['012', '013'].includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.23' && ['012', '013', '113', '114', '115'].includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="(table_number === '1.24' || table_number === '1.27')
                                    && data.item.line_code.endsWith('1')
                                    && ['evaluation'].includes(data.field.key)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.25' && ['014'].includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === '1.26' && ['024'].includes(data.item.line_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="
                            table_number === '1.30' &&
                            (
                              (
                                ['020', '030'].includes(data.item.line_code) &&
                                ['fact'].includes(data.field.key)
                              ) ||
                              (
                                ['050', '060'].includes(data.item.line_code) &&
                                ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].includes(data.field.key)
                              )
                            )">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="updateInputValue(data, data.item.line_code)"
                                   :class="{
                                    'disabled-input':
                                      (source === 'main') ||
                                      (source === 'app6' && (access_level === 1 || !actualVersion))}"
                                   :disabled="
                                    (source === 'main') ||
                                    (source === 'app6' && (access_level === 1 || !actualVersion)) "
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else>
                            <span
                                v-if="hasError(data.item.line_code, data.field.key, table_number)"
                                class="warning-icon"
                                :title="hasError(data.item.line_code, data.field.key, table_number).text"
                            >⚠</span>
                            {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                        </template>
                    </div>
                </template>

            </b-table>
        </div>
        <ForecastUONoteTables
            v-if="showNoteTable"
            :table_number="selectedTableNum"
            :table_name6="selectedTableName"
            :table_code="selectedTableCode"
            :year="year"
            :region="region"
            :dataType="dataType"
            :version="version"
            :source="noteSource"
            @back-to-pkfo="closeNote"
        />
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import moment from "moment";
import {Ax} from "@/utils";
import ForecastUONoteTables from "@/modules/forecast-reporting/ForecastUONoteTables";

export default {
    name: 'forecast-app6-tables',
    components: {
        'loading': VueElementLoading, ForecastUONoteTables
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        table_number: String,
        source: {
            type: String,
            default: 'main'
        },
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            allOpen: false,
            table1_1: [],
            formApp6: [],
            currentView: 'pr6Inc',
            repdate: null,
            openRows: {},
            openCls: {},
            inputValues: [],
            costTableNumbers: ['1.3', '1.6', '1.7', '1.8', '1.9', '1.10', '1.16'],
            moveTableNumbers: ['1.4', '1.11', '1.12', '1.13', '1.14', '1.17'],
            balanceTableNumbers: ['1.22', '1.23', '1.24', '1.25', '1.26', '1.27'],
            inputType118: ['410', '411', '414', '510', '514', '570', '620', '911'],
            inputType120: ['401', '402', '403', '404', '405', '406', '711', '713', '714'],
            totalRow: {
                fcat: 0,
                evaluation: 0,
                forecast_1: 0,
                forecast_2: 0,
                forecast_3: 0,
            },
            showNoteTable: false,
            selectedTableNum: null,
            selectedTableName: null,
            selectedTableCode: null,
            noteSource: null,
        }
    },
    async mounted() {
        if (this.table_number === '1.1' || this.table_number === '1.5' || this.table_number === '1.15'){
            await this.LoadDataTableIncome();
        } else if (this.costTableNumbers.includes(this.table_number)) {
            await this.LoadDataTableCost();
        } else if (this.moveTableNumbers.includes(this.table_number)) {
            await this.LoadDataTableMovement();
        } else if (this.table_number === '1.18'){
            await this.LoadDataPkfo3();
        } else if (this.table_number === '1.20'){
            await this.LoadDataPkfo2();
        } else if (this.balanceTableNumbers.includes(this.table_number)) {
            await this.LoadDataTableBalance();
        } else if (this.table_number === '1.30'){
            await this.LoadDataPkfo4();
        } else if (this.table_number === '1.28'){
            await this.LoadDataPkfo1();
        } else {
            this.formApp6 = [];
        }
    },
    computed: {
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        },
        flattenedItems() {
            const flatten = (items, level = 0) => {
                return items.flatMap(item => {
                    item.level = level; // добавляем level напрямую
                    const children = item.child?.length
                        ? flatten(item.child, level + 1)
                        : [];
                    return item.visible ? [item, ...children] : [];
                });
            };
            return flatten(this.formApp6);
        },
        tableFields1_1() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'action',
                    label: ' ',
                    class: 'toggle-show'
                },
                {
                    key: 'kat',
                    label: 'Категория',
                    rowspan: 2
                },
                {
                    key: 'clss',
                    label: 'Класс',
                    rowspan: 2
                },
                {
                    key: 'pcl',
                    label: 'Подкласс',
                    rowspan: 2
                },
                {
                    key: 'spf',
                    label: 'Специфика',
                    rowspan: 2
                },
                {
                    key: 'name_ru',
                    label: 'Наименование',
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];
        },
        tableFieldsCost() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'action',
                    label: ' ',
                    class: 'toggle-show'
                },
                {
                    key: 'pcl',
                    label: 'Подкласс Единой бюджетной классификации',
                    rowspan: 2
                },
                {
                    key: 'spf',
                    label: 'Специфика Единой бюджетной классификации',
                    rowspan: 2
                },
                {
                    key: 'name_ru',
                    label: 'Наименование',
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];
        },
        tableFieldsMovement() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;
            const labelName = this.table_number === '1.18' || this.table_number === '1.30' ?
                'Показатели' : 'Наименование';

            const fields = [
                {
                    key: 'name_ru',
                    label: labelName,
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];

            if (this.source && this.source === 'main' && this.table_number !== '1.30') {
                fields.splice(1, 0, {
                    key: 'note_number',
                    label: '№ примечания',
                    rowspan: 2
                });
            }

            return fields;
        },
        dropdownLabel() {
            if (this.source === 'main' && this.table_number === '1.28') {
                return 'ПКФО-1МБ'
            } else if (this.source === 'main' && this.table_number === '1.20') {
                return 'ПКФО-2МБ'
            } else if (this.source === 'main' && this.table_number === '1.18') {
                return 'ПКФО-3МБ'
            } else if (this.source === 'main' && this.table_number === '1.30') {
                return 'ПКФО-4МБ'
            } else {
                return 'Приложение 6';
            }
        }
    },
    beforeUpdate() {
        this.formApp6.forEach(row => {
            if ([1, 2, 3].includes(row.type)) {
                row._rowVariant = 'info';
            }
        });
    },
    methods: {
        hasError(lineCode, field, table_num) {
            const tableMap = {
                '1.28': 'pkfo1',
                '1.20': 'pkfo2',
                '1.18': 'pkfo3',
                '1.30': 'pkfo4'
            };
            const table = tableMap[table_num];

            return this.checkDataList.find(item =>
                (
                    (
                        item.checked_form === table &&
                        String(item.checked_line_code) === String(lineCode)
                    ) ||
                    (
                        item.agreed_form === table &&
                        String(item.agreed_line_code) === String(lineCode)
                    )
                ) &&
                item[field]
            );
        },
        hasDataError(lineCode, item, field, table_num) {
            const tableMap = {
                '1.1': 'PR6_tab',
                '1.3': 'PR6_tab',
                '1.5': 'PR6_tab',
                '1.16': 'PR6_tab'
            };
            const table = tableMap[table_num];

            const codesToCheck = [String(lineCode)];
            // отображает знак предупреждение на всех уровнях (kat=2, clss=1, pcl=7)
            if (table_num === '1.1' && item && (String(item.full_code) === '201700' || String(item.full_code) === '201000')) {
                codesToCheck.push('200');
            }

            return this.checkDataList.find(entry =>
                entry.agreed_form === table &&
                entry.table_num === table_num &&
                codesToCheck.includes(String(entry.agreed_line_code)) &&
                entry[field]
            );
        },
        getErrorTitle(lineCode, item, field, table_num) {
            const error = this.hasDataError(lineCode, item, field, table_num);
            if (!error) return '';

            // свои сообщения по таблицам
            const titleMap = {
                '1.1': `Значение не соответствует контролю: строка 1 графы 9, Приложение 9 =
                строка "Вознаграждения по кредитам, выданным из государственного бюджета", Приложение 6, 1.1`,
                '1.3': `Значение не соответствует контролю: строка «Итого», Форма Приложение 7 = строка 070 + 080, Приложение 6, 1.3`,
                '1.5': `Значение не соответствует контролю: строка 1 графы 6, Приложение 9 = строка 600, Приложение 6, 1.5`,
                '1.16': `Значение не соответствует контролю: строка 100 + 200, Приложение 8 = строка 020, Приложение 6, 1.16`
            };

            return titleMap[table_num] || error.text;
        },
        closeNote() {
            this.showNoteTable = false;
            this.noteSource = null;
        },
        getNotes(note) {
            if (!note) {
                return []
            }

            return String(note)
                .split(',')
                .map(item => item.trim())
        },
        openNote(tableNum, tableName, tableCode) {
            this.selectedTableNum = tableNum;
            this.selectedTableName = tableName;
            this.selectedTableCode = tableCode;
            this.showNoteTable = true;
            this.noteSource = 'app6';
        },
        getNoteTooltip(note) {
            if (note === '18') {
                return 'Сумма заимствования'
            }

            if (note === '19') {
                return 'Вычитание денежных средств и их эквивалентов из суммы долга и обязательств по договорам ' +
                    'государственно-частного партнерства'
            }
            if (note === '33') {
                return 'Сложение чистого операционного сальдо и прочих экономических потоков, включенных в результат ' +
                    'операционной деятельности'
            }
            if (note === '34') {
                return ' Вычитание из результата операционной деятельности разницы между нефтяными' +
                    ' доходами и нефтяными расходами.'
            }
            if (note === '35') {
                return 'Вычитание из чистого операционного сальдо чистого приобретения нефинансовых активов.'
            }
            if (note === '36') {
                return 'Сложение чистого кредитования (заимствования) и чистого движения денежных средств по ' +
                    'операциям с финансовыми активами для осуществления мер политики'
            }
            if (note === '37') {
                return 'Вычитание из общего сальдо бюджета разницы между нефтяными доходами и нефтяными расходами ' +
                    'и разницы от операций с нефинансовыми активами (нефтяной)'
            }

            return ''
        },
        rowClass(item) {
            if (this.table_number === '1.18' && item.line_code == null) {
                return 'bg-main-blue';
            } else if (this.table_number === '1.18' && item.line_code.endsWith('00')) {
                return 'bg-light-blue';
            } else if ((this.table_number === '1.22' || this.table_number === '1.23')
                && item.line_code == null && item.name_ru !== 'Активы') {
                return 'bg-main-blue';
            } else if (this.table_number === '1.24' && item.line_code.endsWith('00')) {
                return 'bg-main-blue';
            } else if (this.table_number === '1.24' && item.line_code.endsWith('0')
                && item.line_code !== '100' && item.line_code !== '200') {
                return 'bg-light-blue';
            } else if (this.table_number === '1.25' && item.line_code.endsWith('00')) {
                return 'bg-main-blue';
            } else if (this.table_number === '1.27' && item.line_code.endsWith('0')) {
                return 'bg-main-blue';
            } else if (this.table_number === '1.28' && item.line_code == null
                && item.name_ru !== 'Активы' && item.name_ru !== 'Обязательства, чистые активы/капитал') {
                return 'bg-main-blue';
            }
            return '';
        },
        updateInputValue(data, line_code){
            if (data.value !== null && data.value !== 0) {
                const existingEntryIndex = this.inputValues.findIndex(entry => {
                    if (this.table_number === '1.13') {
                        return entry.dict_code === '113' + line_code;
                    } else {
                        return entry.line_code === line_code;
                    }
                });
                if (existingEntryIndex !== -1) {
                    // Update the specific field for an existing entry
                    this.$set(this.inputValues[existingEntryIndex], data.field.key, data.value);
                } else if (data.value !== null) {
                    // Create a new entry if it doesn't exist and the value is not null
                    const newEntry = {
                        ...(this.table_number === '1.13'
                            ? { dict_code: '113' + line_code }
                            : { line_code: line_code }),
                        fact: data.field.key === 'fact' ? data.value : null,
                        evaluation: data.field.key === 'evaluation' ? data.value : null,
                        forecast_1: data.field.key === 'forecast_1' ? data.value : null,
                        forecast_2: data.field.key === 'forecast_2' ? data.value : null,
                        forecast_3: data.field.key === 'forecast_3' ? data.value : null
                    };
                    this.inputValues.push(newEntry);
                }
            }
            if (['1.13', '1.22', '1.23', '1.25', '1.26'].includes(this.table_number)) {
                this.$set(data.item, data.field.key, data.value);
            }
            if (this.table_number === '1.18'){
                const child = this.formApp6.find(item => item.line_code === line_code);
                this.$set(child, data.field.key, data.value);
                // 400
                const mainRow = this.formApp6.find(item => item.line_code === '400');
                const totalRows = this.formApp6.filter(item => ['410', '411', '412', '413', '414'].includes(item.line_code));
                if (mainRow && totalRows) {
                    const res = totalRows.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow, data.field.key, this.toNum(res));
                }
                // 500
                const mainRow5 = this.formApp6.find(item => item.line_code === '500');
                const totalRows5 = this.formApp6.filter(item => ['510', '511', '512', '513', '514'].includes(item.line_code));
                if (mainRow5 && totalRows5) {
                    const res = totalRows5.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow5, data.field.key, this.toNum(res));
                }
                // 600
                const mainRow6 = this.formApp6.find(item => item.line_code === '600');
                if (mainRow6 && mainRow5 && mainRow) {
                    const res = (parseFloat(mainRow[data.field.key]) - parseFloat(mainRow5[data.field.key])) || 0;
                    this.$set(mainRow6, data.field.key, this.toNum(res));
                }
                // 700
                const mainRow7 = this.formApp6.find(item => item.line_code === '700');
                const totalRows7 = this.formApp6.filter(item => ['610', '620'].includes(item.line_code));
                if (mainRow7 && totalRows7) {
                    const res = totalRows7.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow7, data.field.key, this.toNum(res));
                }
                // 930
                const mainRow93 = this.formApp6.find(item => item.line_code === '930');
                const totalRows93 = this.formApp6.filter(item => ['910', '920', '911'].includes(item.line_code));
                if (mainRow93 && totalRows93) {
                    const res = totalRows93.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow93, data.field.key, this.toNum(res));
                }
            }
            if (this.table_number === '1.20'){
                const child = this.formApp6.find(item => item.line_code === line_code);
                this.$set(child, data.field.key, data.value);
                // 400
                const mainRow = this.formApp6.find(item => item.line_code === '400');
                const totalRows = this.formApp6.filter(item => ['401', '402', '403', '404', '405', '406'].includes(item.line_code));
                if (mainRow && totalRows) {
                    const res = totalRows.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow, data.field.key, this.toNum(res));
                }
                // 800
                const mainRow8 = this.formApp6.find(item => item.line_code === '800');
                const totalRows8 = this.formApp6.filter(item => ['710', '711', '712', '713', '714'].includes(item.line_code));
                if (mainRow8 && totalRows8) {
                    const signs = {
                        '710': 1,
                        '711': -1,
                        '712': -1,
                        '713': 1,
                        '714': 1};

                    const res = totalRows8.reduce((acc, row) => {
                        const val = parseFloat(row[data.field.key]) || 0;
                        return acc + signs[row.line_code] * val;
                    }, 0);
                    this.$set(mainRow8, data.field.key, this.toNum(res));
                }
            }
            if (this.table_number === '1.24' || this.table_number === '1.27'){
                const child = this.formApp6.find(item => item.line_code === line_code);
                this.$set(child, data.field.key, data.value);

                const prefix = line_code.slice(0, 2);
                const code1 = prefix + '1'; // X1
                const code2 = prefix + '2'; // X2
                const code3 = prefix + '3'; // X3
                const code4 = prefix + '4'; // X4

                const row1 = this.formApp6.find(item => item.line_code === code1);
                const row2 = this.formApp6.find(item => item.line_code === code2);
                const row3 = this.formApp6.find(item => item.line_code === code3);
                const row4 = this.formApp6.find(item => item.line_code === code4);

                if (!(row1 && row2 && row3 && row4)) {
                    return;
                }

                const val1 = parseFloat(row1['evaluation']) || 0;
                const val2 = parseFloat(row2['evaluation']) || 0;
                const val3 = parseFloat(row3['evaluation']) || 0;
                this.$set(row4, 'evaluation', this.toNum(val1 + val2 - val3));

                for (let i = 1; i <= 3; i++) {
                    const fKey = `forecast_${i}`;

                    if (i === 1) {
                        // row1.forecast_1 = row4.evaluation
                        this.$set(row1, fKey, this.toNum(row4['evaluation']));
                    } else {
                        // row1.forecast_i = row1.forecast_(i-1)
                        this.$set(row1, fKey, this.toNum(row4[`forecast_${i - 1}`]));
                    }

                    const f1 = parseFloat(row1[fKey]) || 0;
                    const f2 = parseFloat(row2[fKey]) || 0;
                    const f3 = parseFloat(row3[fKey]) || 0;
                    this.$set(row4, fKey, this.toNum(f1 + f2 - f3));
                }
            }
            if (this.table_number === '1.30'){
                const child = this.formApp6.find(item => item.line_code === line_code);
                this.$set(child, data.field.key, data.value);

                const mirrorMap = {
                    'fact': 'evaluation',
                    'evaluation': 'forecast_1',
                    'forecast_1': 'forecast_2',
                    'forecast_2': 'forecast_3',
                };

                if (['050', '060'].includes(line_code)) {
                    const targetCode = line_code === '050' ? '020' : '030';
                    const target = this.formApp6.find(item => item.line_code === targetCode);
                    const targetField = mirrorMap[data.field.key];

                    if (target && targetField) {
                        this.$set(target, targetField, data.value);
                    }
                }

                // 010
                const mainRow = this.formApp6.find(item => item.line_code === '010');
                let totalRows;

                if (data.field.key === 'fact') {
                    totalRows = this.formApp6.filter(item => ['020', '030'].includes(item.line_code));
                    const res = totalRows.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow, data.field.key, this.toNum(res));
                }
                totalRows = this.formApp6.filter(item => ['050', '060'].includes(item.line_code));
                const res = totalRows.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                this.$set(mainRow, mirrorMap[data.field.key], this.toNum(res));

                // 040
                const mainRow4 = this.formApp6.find(item => item.line_code === '040');
                const totalRows4 = this.formApp6.filter(item => ['050', '060'].includes(item.line_code));
                if (mainRow4 && totalRows4) {
                    const res = totalRows4.reduce((acc, row) => acc + (parseFloat(row[data.field.key]) || 0), 0);
                    this.$set(mainRow4, data.field.key, this.toNum(res));
                }
            }
        },
        async LoadApplyButton(){
            if (this.table_number === '1.1' || this.table_number === '1.5' || this.table_number === '1.15'){
                await this.LoadDataTableIncome();
            } else if (this.costTableNumbers.includes(this.table_number)) {
                await this.LoadDataTableCost();
            } else if (this.moveTableNumbers.includes(this.table_number)){
                await this.LoadDataTableMovement();
            } else if (this.table_number === '1.18'){
                await this.LoadDataPkfo3();
            } else if (this.table_number === '1.20'){
                await this.LoadDataPkfo2();
            } else if (this.balanceTableNumbers.includes(this.table_number)){
                await this.LoadDataTableBalance();
            } else if (this.table_number === '1.30'){
                await this.LoadDataPkfo4();
            } else if (this.table_number === '1.28'){
                await this.LoadDataPkfo1();
            }
        },
        async LoadDataTableIncome() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_income_from_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp6 = await response.json();

                    const totalArray = this.formApp6;
                    ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                        const sum = totalArray.reduce((acc, item) => acc + (parseFloat(item[key]) || 0), 0);
                        this.$set(this.totalRow, key, this.toNum(sum));
                    });

                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы Доходов', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTableCost() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_cost_from_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp6 = await response.json();

                    const totalArray = this.formApp6;
                    ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                        const sum = totalArray.reduce((acc, item) => acc + (parseFloat(item[key]) || 0), 0);
                        this.$set(this.totalRow, key, this.toNum(sum));
                    });

                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы Расходов', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTableMovement() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_movement_from_app6/` + this.region + '/' + this.year + '/' + this.dataType +  '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы Движения', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTableBalance() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_balance_from_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    const data = await response.json();
                    this.formApp6 = data.result;
                    this.inputValues = data.input;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблиц Баланса', error.toString());
            }
            this.loading = false;
        },
        async LoadDataPkfo3() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_pkfo3_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки ПКФО-3', error.toString());
            }
            this.loading = false;
        },
        async LoadDataPkfo2() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_pkfo2_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки ПКФО-2', error.toString());
            }
            this.loading = false;
        },
        async LoadDataPkfo4() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_pkfo4_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                    const fields = ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                    fields.forEach(key => {
                        ['020', '030', '050', '060'].forEach(line_code => {
                            const row = this.formApp6.find(item => item.line_code === line_code);
                            if (row && row[key] !== null && row[key] !== undefined) {
                                this.updateInputValue({
                                    value: row[key],
                                    field: { key }
                                }, row.line_code);
                            }
                        });
                    });
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки ПКФО-4', error.toString());
            }
            this.loading = false;
        },
        async LoadDataPkfo1() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_table_pkfo1_app6/` + this.region + '/' + this.year + '/' + this.dataType + '/' + this.version);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки ПКФО-4', error.toString());
            }
            this.loading = false;
        },
        async SaveDataMovement() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_app6_movement', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveDataPKFO3() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_3mb', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveDataPKFO2() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_2mb', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveDataPKFO4() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_4mb', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveDataBalance() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_app6_balance', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name, table_num: this.table_number, source: this.source };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_download_app6/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileName = this.dropdownLabel + '.xlsx';
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toNum(value, fix = 1) {
            if (typeof value === 'string') {
                if (value.trim() === '') {
                    return 0; // или можно вернуть null, если не хочешь показывать 0
                }
                const num = parseFloat(value.replace(',', '.'));
                return isNaN(num) ? 0 : parseFloat(num.toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
        openChilds(parent, bool) {
            const newState = (bool === undefined ? !parent.open : bool);
            this.$set(parent, 'open', newState);

            if (parent.child && parent.child.length) {
                for (const row of parent.child) {
                    this.$set(row, 'visible', newState);

                    if ([1, 2, 3].includes(row.type)) {
                        this.$set(row, 'open', false);
                    }
                }
            }
        },
        openAllChilds() {
            this.allOpen = !this.allOpen;
            const newState = this.allOpen;
            for (const item of this.formApp6) {

                if ([1, 2, 3].includes(item.type)) {
                    if (item.type === 1 || item.type === 3) {
                        this.$set(item, 'open', true);
                        this.$set(item, 'visible', true);
                    } else {
                        this.$set(item, 'open', newState);
                        this.$set(item, 'visible', newState);
                    }
                    this.openAllChildsRecursive(item, newState);
                }
            }
        },
        openAllChildsRecursive(parent, bool) {
            if (!parent.child || !parent.child.length) return;

            for (const row of parent.child) {
                this.$set(row, 'visible', bool);

                if ([1, 2, 3].includes(row.type)) {
                    this.$set(row, 'open', bool);
                    this.openAllChildsRecursive(row, bool);
                }
            }
        }

    }
}
</script>

<style>
.bg-main-blue {
    background-color: #d9f0ff !important;
}
.bg-light-blue {
    background-color: #e8f4fa !important;
}
</style>

